import { takeEvery } from "@redux-saga/core/effects";
import { call, put } from "redux-saga/effects";

import * as types from "../Types/BrandActionTypes";
import * as actions from "../Actions/BrandActions";
import * as api from "../API/BrandApi";
import { IBrand } from "../../../Models/Models";
import { IBrandSampleSet } from "../../../Models/IBrandSampleSet";
import { IGetBrandsSampleSetDataByClosestRequest } from "../../../Models/Requests/IGetBrandsSampleSetDataByClosestRequest";
import { IGetBrandsSampleSetDataByGeoRequest } from "../../../Models/Requests/IGetBrandsSampleSetDataByGeoRequest";

export function* watchBrandSagas() {
    yield takeEvery(types.GET_ALL_BRANDS_INITIATE, getAllBrandsSaga);
    yield takeEvery(
        types.GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_INITIATE,
        getBrandSampleSetLocationsByGeoSaga
    );
    yield takeEvery(
        types.GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_INITIATE,
        getBrandSampleSetLocationsByClosestSaga
    );
}

export function* getAllBrandsSaga() {
    try {
        yield put(actions.setLoadingBrands(true));
        const brands: IBrand[] = yield call(api.getBrands);
        yield put(actions.getAllBrandsSuccess(brands));
    } catch (e) {
        yield put(actions.getAllBrandsFailure(e));
    } finally {
        yield put(actions.setLoadingBrands(false));
    }
}

export function* getBrandSampleSetLocationsByGeoSaga(
    action: types.GetBrandSampleSetLocationsByGeoInitiateAction,
) {
    try {
        yield put(actions.setLoadingBrandSampleSetLocations(true));
        const request = action.data as IGetBrandsSampleSetDataByGeoRequest;
        const brands: IBrandSampleSet[] = yield call(() =>
            api.getBrandSampleSetLocationsByGeo(request)
        );
        yield put(actions.getBrandSampleSetLocationsByGeoSuccess(brands, action.correlationId));
    } catch (e) {
        yield put(actions.getBrandSampleSetLocationsByGeoFailure(e, action.correlationId));
    } finally {
        yield put(actions.setLoadingBrandSampleSetLocations(false));
    }
}

export function* getBrandSampleSetLocationsByClosestSaga(
    action: types.GetBrandSampleSetLocationsByClosestInitiateAction
) {
    try {
        yield put(actions.setLoadingBrandSampleSetLocations(true));
        const request = action.data as IGetBrandsSampleSetDataByClosestRequest;
        const brands: IBrandSampleSet[] = yield call(() =>
            api.getBrandSampleSetLocationsByClosest(request)
        );
        yield put(actions.getBrandSampleSetLocationsByGeoSuccess(brands, action.correlationId));
    } catch (e) {
        yield put(actions.getBrandSampleSetLocationsByGeoFailure(e, action.correlationId));
    } finally {
        yield put(actions.setLoadingBrandSampleSetLocations(false));
    }
}
